import { TextKey, SearchType } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import SearchFormField from '../../../../components/form/SearchFormField';

const CitySearchField = ({ preselectedResultId }: $TSFixMe) => (
    <SearchFormField {...cityProps} preselectedResultId={preselectedResultId} scope="city-form" required />
);

const cityProps = {
    label: <LocalizedText textKey={TextKey.City} />,
    name: 'cityId',
    searchType: SearchType.City,
};

export default CitySearchField;
